import { render } from "./nav-icon.vue?vue&type=template&id=7234afdc"
import script from "./nav-icon.vue?vue&type=script&lang=js"
export * from "./nav-icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__